import React, {useEffect, useState} from "react";

// Material-UI
import {
    Button,
    CircularProgress, Dialog, DialogActions, DialogTitle,
    Grid,
    Typography,
} from "@material-ui/core"

const AreYouSure = ({open, handleClose, message, confirmMethod}) => {

    const executeAndClose = async () => {
        await confirmMethod();
        handleClose();
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            width={"50vw"}
        >
            <DialogTitle id="alert-dialog-title">{message}</DialogTitle>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={executeAndClose} color="secondary" autoFocus>
                    Yes, I am sure
                </Button>
            </DialogActions>
        </Dialog>
    )

};

export default AreYouSure;
